import isInteger from 'lodash/isInteger';

export function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 16;

  if (!isInteger(length)) {
    throw new Error('Invalid input \'' + length + '\', please provide a number');
  }

  var str = '';

  while (str.length < length) {
    str += Math.round(Math.random() * 2147483647).toString(36);
  }

  return str.substr(0, length);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-cis-sync/dist/ejs/utils.js
// module id = 1177
// module chunks = 0